import { render } from "./WhereBuy.vue?vue&type=template&id=2d504f8e&scoped=true"
import script from "./WhereBuy.vue?vue&type=script&lang=js"
export * from "./WhereBuy.vue?vue&type=script&lang=js"

import "./WhereBuy.vue?vue&type=style&index=0&id=2d504f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d504f8e"]])

export default __exports__